export default "__VITE_ASSET__BcsVxeXN__"